<template>
  <b-button
    pill
    variant="danger"
    class="w-100 w-md-auto my-3 my-md-auto report_option_button del_report_btn"
    :disabled="modalDisabled"
    @click="withdraw"
    aria-label="Delete Report"
  >
    Delete Report
    <b-modal
      ref="withdrawReportConfirmation"
      content-class="px-lg-5"
      id="withdrawReportConfirmation"
      title="Delete this Landowner Report"
      footer-class="text-center"
      centered
      hide-header-close
      size="lg"
    >
      You are deleting this landowner report. Are you sure you want to delete this landowner report? (Note: this is NOT deleting this Forest Operations Notification (FON))
      <div slot="modal-footer" class="d-flex">
        <b-button
        pill
        variant="danger"
        class="mr-3 btn_min_width"
        @click="hideModal"
        aria-label="Cancel deleting this Landowner Report"
      >
          No
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="withdrawReport(reportId)"
          :disabled="mfsAdmin"
          aria-label="Confirm deleting this Landowner Report"
        >
          Yes, delete
        </b-button>
      </div>
    </b-modal>
  </b-button>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Utilities from '@/mixins/Utilities';

export default {
  name: 'WithdrawReportModal',
  mixins: [Utilities],
  props: {
    modalDisabled: {
      type: Boolean,
      default: true,
    },
    reportId: {
      type: Number,
    },
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapGetters('User', ['mfsAdmin']),
  },
  methods: {
    withdraw() {
      this.$refs.withdrawReportConfirmation.show();
    },
    withdrawReport(reportId) {
      if (this.mfsAdmin) {
        return;
      }
      this.$store.dispatch(
        'LandownerReport/withdraw',
        reportId,
      ).then(() => {
        this.hideModal();
        this.$parent.updateReportList();
      });
      this.$emit('withdrawReport');
    },
    hideModal() {
      this.$refs.withdrawReportConfirmation.hide();
    },
  },
};
</script>
<style>
.btn_min_width{
  min-width: 110px;
}
.report_option_button {
      font-size: 1rem;
  }
@media (min-width: 1199px) and (max-width:1499px){
  .report_option_button {
      font-size: 0.7rem;
  }
}
@media (min-width: 768px) and (max-width:912px){
  .report_option_button {
      font-size: 0.7rem;
  }
}
@media (max-width: 767px){
  .del_report_btn {
    margin-left: -0.5rem !important;
  }
}
</style>
